import { render, staticRenderFns } from "./InvoicePayDetail.vue?vue&type=template&id=8b5248b0&"
import script from "./InvoicePayDetail.vue?vue&type=script&lang=js&"
export * from "./InvoicePayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports